@if (!isCancelWindowOpen) {
  @if (currentSection.value === sectionENum.hub) {
    <div class="hub-section">
      <p class="h1 black uppercase text-center">
        Выберите, что хотите изменить
      </p>
      @for (section of sectionForFields;  let index = $index ;track $index; ) {
        <div class="field-section" (click)="goToSecetedSection(section.type)" (mouseenter)="arrowMouseEnter(index)" (mouseleave)="arrowMouseLeave()" >
          <div class="field-title uppercase black">
            {{ section.title }}
          </div>
          <div   class="field-arrow">
                @if(arrowFieldState() === index){
                  <img src="/assets/images/login/arrow-small.svg">
                }@else {
                  <img src="/assets/images/login/arrow.svg">
                }
          </div>
        </div>
      }
    </div>
  } @else if (currentSection.value === sectionENum.phone) {
    <div class="form-block">
      <div class="head-section">
        @if (sectionForFields.length > 1) {
          <div class="head-back-button" (click)="goToHub()" (mouseenter)="arrowMouseEnter()" (mouseleave)="arrowMouseLeave()">
            @if(arrowFieldState()){
              <img src="/assets/images/login/arrow-small.svg">
            }@else {
              <img src="/assets/images/login/arrow.svg">
            }
          </div>
        }
        <div class="head-text">
          <p class="h1 black uppercase text-center">
            Измените номер телефона
          </p>
        </div>
      </div>
      <form class="phone-block" [formGroup]="phoneForm">
        <div class="some-input-and-label">
          <input
            [style]="phoneErrorMessage ? 'border-color: #E94848;' : ''"
            class="text-form"
            id="phoneNumber"
            type="tel"
            inputmode="numeric"
            placeholder="+7 (___) ___-__-__"
            formControlName="phoneNumber"
            name="phoneNumber"
            phoneMaskForm
            (focus)="onPhoneFocus()"
            (blur)="onPhoneBlur()"
            (input)="onPhoneInput()"
            [class]="{ 'input-error': (phoneTouched && !phoneFocused && hasFieldError(phoneForm, 'phoneNumber')) || phoneErrorMessage}"
          />

            <div>
              @if(phoneErrorMessage){
                <span class="text-error">
              {{ phoneErrorMessage }}
            </span>
              }@else if(!phoneErrorMessage && phoneTouched && !phoneFocused && hasFieldError(phoneForm, 'phoneNumber')){
                <span class="text-error">Это поле обязательно для заполнения</span>
              }
            </div>

        </div>
        <app-button
          [disabled]="phoneDisable()"
          [title]="'Отправить код'"
          (click)="onPhoneSubmit()"
          [isLoading]="isLoading()">
        </app-button>
      </form>
    </div>
  } @else if (currentSection.value === sectionENum.confirmPhone) {
    <div class="form-block">
      <div class="head-section">
        <div class="head-50-back-button" (click)="goToSecetedSection(EditFieldSection.phone)">
          <img src="/assets/images/login/arrow.svg">
        </div>
        <div class="head-text">
          <p class="h1 black uppercase text-center">
            Подтвердите номер телефона
          </p>
        </div>
      </div>
      <h5 class="text-3 text-center text-sended-code">
        На номер {{
          phoneForm.get("phoneNumber")?.value | phoneNumberFormat
        }}
        отправлен проверочный код
      </h5>
      <form class="phone-block" [formGroup]="phoneForm">
        <div class="some-input-and-label">
          <input
            [style]="errorMessage() ? 'border-color: #E94848;' : ''"
            class="text-form code"
            id="code"
            type="number"
            [placeholder]="isPhoneCodeFocused ? '' : 'Введите код'"
            (focus)="isPhoneCodeFocused = true"
            (blur)="isPhoneCodeFocused = false"
            formControlName="code"
            name="code"
            mask="0000"
            (input)="errorMessage.set(null)"
            [class]="{ 'input-error': !isPhoneCodeFocused && hasFieldError(phoneForm, 'code') || errorMessage()}"
          />

            <div>
              @if(errorMessage()){
                <span class="text-error">
                {{ errorMessage()}}
              </span>
              }@else if(!errorMessage() && !isPhoneCodeFocused && hasFieldError(phoneForm, 'code')){
               <span class="text-error">
                Это поле обязательно для заполнения
              </span>
             }
            </div>
        </div>

        <app-button
          [title]="'Подтвердить'"
          (click)="onPhoneCodeSubmit()"
          [isLoading]="isLoading()"
          [disabled]="phoneForm.get('code')?.invalid  || !!errorMessage()">
        </app-button>
        @if (timerStatus()) {
          <button class="get-code-btn" disabled>
         <span class="text-1 resend-code">Повторная отправка будет доступна через <br />
            (@if (timer().hoursLeft) {
             {{ timer().hoursLeft | number: '2.0' }}:
           }
           {{ timer().minutesLeft | number: '2.0' }}:
           {{ timer().secondsLeft | number: '2.0' }})
         </span>
          </button>
        } @else {
          <ng-template >
            <app-button
              [title]="'Отправить код повторно'"
              [variant]="'outline'"
              (click)="sendEmailConfirmation(this.emailForm.get('email')?.value!)"
            >
            </app-button>
          </ng-template>
        }
      </form>
    </div>
  } @else if (currentSection.value === sectionENum.email) {
    <div class="form-block">
      <div class="head-section">
        @if (sectionForFields.length > 1) {
          <div class="head-50-back-button" (click)="goToHub()">
            <img src="/assets/images/login/arrow.svg">
          </div>
        }
        <div class="head-text">
          <p class="h1 black uppercase text-center">
            Измените почту
          </p>
        </div>
      </div>
      <form class="phone-block" [formGroup]="emailForm">
        <div class="some-input-and-label">
          <input
            formControlName="email"
            class="text-form"
            [placeholder]="isFocusedEmail ? '' : 'Введите почту'"
            (focus)="isFocusedEmail = true"
            (blur)="isFocusedEmail = false"
            noWhitespace
            (input)="errorMessage.set(null)"
            [class]="{ 'input-error': getErrorTypeFromForm(emailForm, 'email') || errorMessage() }"
          />
          @if (getErrorTypeFromForm(emailForm, 'email')) {
            <p class="text-error">
              {{ getErrorTypeFromForm(emailForm, 'email') }}
            </p>
          } @else if (errorMessage()) {
            <p class="text-error">
              {{ errorMessage() }}
            </p>
          }
        </div>
        <app-button
          [disabled]="emailDisable()"
          [title]="'Отправить код'"
          (click)="onEmailSubmit()"
          [isLoading]="isLoading()"
        >
        </app-button>
      </form>
    </div>
  } @else if (currentSection.value === sectionENum.confirmEmail) {
    <div class="form-block">
      <div class="head-section">
        <div class="head-50-back-button" (click)="goToSecetedSection(EditFieldSection.email)">
          <img src="/assets/images/login/arrow.svg">
        </div>

        <div class="head-text">
          <p class="h1 black uppercase text-center">
            Подтвердите почту
          </p>
        </div>
      </div>
      <h5 class="text-3 text-center text-sended-code">
        На почту {{ emailForm.get("email")?.value }} отправлен проверочный код
      </h5>
      <form class="phone-block" [formGroup]="emailForm">
        <div class="some-input-and-label">
          <input
            [style]="errorMessage()  ? 'border-color: #E94848;' : ''"
            class="text-form code"
            id="code"
            type="number"
            [placeholder]="isFocusedEmailCode ? '' : 'Введите код'"
            (focus)="isFocusedEmailCode = true"
            (blur)="isFocusedEmailCode = false"
            formControlName="code"
            name="code"
            mask="0000"
            (input)="errorMessage.set(null)"
            [class]="{ 'input-error': !isFocusedEmailCode && hasFieldError(emailForm, 'code') || errorMessage() }"
          />
            <div>
              @if(errorMessage()){
                <span class="text-error" >
                {{ errorMessage() }}
              </span>
              } @else if(!errorMessage() && !isFocusedEmailCode && hasFieldError(emailForm, 'code') ){
                <span class="text-error">Это поле обязательно для заполнения
              </span>
              }
            </div>

        </div>

        <app-button
          [title]="'Подтвердить'"
          (click)="onEmailCodeSubmit()"
          [isLoading]="isLoading()"
          [disabled]="emailForm.get('code')?.invalid || !!errorMessage()"
        >
        </app-button>

        @if (timerStatus()) {
          <button class="get-code-btn" disabled>
         <span class="text-1 resend-code">Повторная отправка будет доступна через <br />
            (@if (timer().hoursLeft) {
              {{ timer().hoursLeft | number: '2.0' }}:
            }
            {{ timer().minutesLeft | number: '2.0' }}:
            {{ timer().secondsLeft | number: '2.0' }})
         </span>
          </button>
        } @else {
          <ng-template >
            <app-button
              [title]="'Отправить код повторно'"
              [variant]="'outline'"
              (click)="sendEmailConfirmation(this.emailForm.get('email')?.value!)"
            >
            </app-button>
          </ng-template>
        }
      </form>
    </div>
  } @else if (currentSection.value === sectionENum.personalData) {
    @if (personalDataForm) {
      <ng-container>
        <form [formGroup]="personalDataForm">
          <div class="form-block">
            <div class="head-section">
              @if (sectionForFields.length > 1) {
                <div class="head-50-back-button" (click)="goToHub()">
                  <img src="/assets/images/login/arrow.svg">
                </div>
              }
              <div class="head-text">
                <p class="h1 black uppercase text-center">
                  Измените данные
                </p>
              </div>
            </div>
            <div class="phone-block">
              @for (item of personalDataFieldItems; track item.name) {
                <div class="some-input-and-label">
                  @if (item.name === 'region') {
                    <label [attr.required]="isRequiredFromForm(personalDataForm, item.name) ? '' : null" class="h3">
                      Регион проживания
                    </label>
                    <mat-form-field appearance="fill" class="region-minimal" (mouseenter)="arrowMouseEnter()" (mouseleave)="arrowMouseLeave()" >
                      <div class="input-wrapper"
                           [class]="{ 'input-error': getErrorTypeFromForm(personalDataForm, item.name) }">
                        <input
                          #regionInput
                          type="text"
                          matInput
                          [formControl]="regionSearchControl"
                          [matAutocomplete]="auto"
                          class="text-form region-input"
                          (focus)="onRegionInputFocus()"
                          (blur)="regionPanelBlur()"
                          [class]="{ 'input-error': getErrorTypeFromForm(personalDataForm, item.name)}"

                        />
                      </div>
                        @if(arrowFieldState()){
                          <img
                            src="/assets/images/login/arrow-small.svg"
                            class="dropdown-arrow"
                            [class.open]="regionPanelIsOpen"
                            alt="arrow"
                          />
                        }@else {
                          <img
                            src="/assets/images/login/arrow.svg"
                            class="dropdown-arrow"
                            [class.open]="regionPanelIsOpen"
                            alt="arrow"
                          />
                        }







                      <mat-autocomplete
                        #auto="matAutocomplete"
                        [displayWith]="displayRegion"
                        (opened)="regionPanelIsOpen = true"
                        (closed)="regionPanelIsOpen = false"
                        (optionSelected)="onRegionSelected($event, item.name)">

                        @if (filteredRegions.length > 0) {
                          @for (option of filteredRegions; track option) {
                            <mat-option [value]="option">
                              {{ option.title }}
                            </mat-option>
                          }
                        } @else {
                          <mat-option disabled>Регион не найден</mat-option>
                        }
                      </mat-autocomplete>
                    </mat-form-field>

                    @if (getErrorTypeFromForm(personalDataForm, item.name)) {
                      <p class="text-error">{{ getErrorTypeFromForm(personalDataForm, item.name) }}</p>
                    }
                  } @else if (item.name === 'birth_date') {
                    <label
                      [attr.required]="isRequiredFromForm(personalDataForm, item.name) ? '' : null"
                      class="h3"
                      [for]="item.name">
                      {{ item.title }}
                    </label>
                    <input
                      [formControlName]="item.name"
                      class="text-form"
                      placeholder="__.__.____"
                      [id]="item.name"
                      type="text"
                      validator-date="[0-9]"
                      [class]="{ 'input-error': getErrorTypeFromForm(personalDataForm, item.name) }"
                    />
                    @if (getErrorTypeFromForm(personalDataForm, item.name)) {
                      <p class="text-error">{{ getErrorTypeFromForm(personalDataForm, item.name) }}</p>
                    }
                  } @else {
                    <label
                      [attr.required]="isRequiredFromForm(personalDataForm, item.name) ? '' : null"
                      class="h3"
                      [for]="item.name"
                    >
                      {{ item.title }}
                    </label>
                    @if(personalDataForm.get(item.name)){
                      <input
                        appOnlyLetters
                        [maxLength]="30"
                        [formControlName]="item.name"
                        class="text-form"
                        [id]="item.name"
                        type="text"
                        [class]="{ 'input-error': getErrorTypeFromForm(personalDataForm, item.name) }"
                      />
                    }
                    @if (getErrorTypeFromForm(personalDataForm, item.name)) {
                      <p class="text-error">{{ getErrorTypeFromForm(personalDataForm, item.name) }}</p>
                    }
                  }
                </div>
              }
              <app-button
                (click)="updatePersonalData()"
                [disabled]="isPersonalDataSaveDisabled"
                [title]="'Сохранить'"
                [isLoading]="isLoading()"
              ></app-button>
            </div>
          </div>
        </form>
      </ng-container>
    }
  } @else if (currentSection.value === sectionENum.successSaved) {
    <div class="success-block">
      <div class="success-text">
        <p class="h1 black uppercase text-center">
          Данные успешно изменены
        </p>
        @if (sectionForFields.length > 1) {
          <h5 class="text-3 text-center">Завершить редактирование?</h5>
        }
      </div>
      <div class="action-button-block">
        @if (sectionForFields.length > 1) {
          <app-button
            (click)="goToBackSite()"
            [title]="'Да, завершить'">
          </app-button>
          <app-button
            (click)="goToHub()"
            [variant]="'outline'"
            [title]="'Нет, продолжить'">
          </app-button>
        } @else {
          <app-button
            (click)="goToBackSite()"
            [title]="'Завершить редактирование'">
          </app-button>
        }
      </div>
    </div>
  } @else if (currentSection.value === sectionENum.zeroFields) {
    <div class="form-block">
      <div class="head-section">
        <div class="head-text">
          <p class="h1 black uppercase text-center">
            Технические неполадки
          </p>
        </div>
      </div>
      <h5 class="text-3 text-center text-sended-code">
        К сожалению, клиент, откуда вы перешли на НФ.ID некорректно задал список необходимых полей для редактирования
      </h5>
      <app-button
        [title]="'Вернуться назад'"
        (click)="goToBackSite()"
        [isLoading]="isLoading()"
      >
      </app-button>
    </div>
  }
} @else {
  <div class="cancel-block">
    <div class="cancel-text">
      <p class="main-cancel-text black uppercase text-center">
        Изменения не сохранены
      </p>
      <h5 class="text-3 text-center" style="text-align: center">Уверены, что хотите выйти?</h5>
    </div>
    <div class="action-button-block">
      <app-button
        (click)="goToBackSite()"
        [title]="'Да, выйти'">
      </app-button>
      <app-button
        (click)="onCanceledCancelEdit()"
        [variant]="'outline'"
        [title]="'Нет, продолжить'">
      </app-button>
    </div>
  </div>
}
